import { api } from '../utils/api';

export const addReserve = async (data) =>
  await api
    .post('reserveNotes/add', data, { headers: { Authorization: 'Basic MTAxOg==' } })
    .then((response) => response);
